// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ArowBackSvg from '@rsuite/icon-font/lib/direction/ArowBack';
var ArowBack = createSvgIcon({
  as: ArowBackSvg,
  ariaLabel: 'arow back',
  category: 'direction',
  displayName: 'ArowBack'
});
export default ArowBack;